<template>
  <div class="col-lg-3 col-md-4 col-xs-6 mb-product">
    <article class="product type-product">
      <div class="figure-grid">
        <div class="image">
          <a :href="productUrl" preserve-state>
            <div class="custom-labels-wrapper position-top">

              <span class="label label-sale label-warning top-left" v-if="product.special_price">Promocja!</span></div>

              <img :src="product.base_image.small" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product image">
          </a>
        </div>
        <div class="text">
          <a :href="productUrl" preserve-state>
            <div class="additional-badges">
              <span class="label label-black">Szybka dostawa</span></div>
            <p class="title">{{ product.name }}</p>
            <ProductRating :ratingPercent="product.rating_percent" :reviewCount="reviewCount"/>
            <span class="price notranslate product-price product-price-clone" v-html="product.formatted_price"></span>


          </a>
          <div class="add-to-cart">
            <a
            v-if="hasAnyOption || hasAnyVariant"
            :href="productUrl"
            class="button product_type_simple add_to_cart_button"
            preserve-state
            >
              {{this.$trans('product::product.add_to_cart_configure')}}
            </a>

            <a
            v-else
            class="button product_type_simple add_to_cart_button"
            :class="{ 'btn-loading': addingToCart }"
            :disabled="product.is_out_of_stock"
            @click="addToCart"
            >
              {{this.$trans('product::product.add_to_cart')}}
            </a>
          </div>
          <div class="product-bottom-informations">
            <div class="colours"></div>
            <div class="dimensions">
            <span v-if="product.size" v-html="product.size">
            </span>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
